const Recipes = () => import("./views/Recipes.vue");
const RecipeEdit = () => import("./views/RecipeEdit.vue");

const route = "/recipes";

export default [
  {
    path: route,
    name: "recipes.list",
    component: Recipes,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN", "ROLE_COOK"],
    },
  },

  {
    path: `${route}/create`,
    name: "recipes.create",
    component: RecipeEdit,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/:recipeId/edit`,
    name: "recipes.edit",
    component: RecipeEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },
];
